import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { ImplementerService } from '../../../../services/implementer/implementer.service';
import { DefaultPage } from '../../../default/default-page/default-page';
import { NavMainMenuPage } from '../../../nav/nav-menus/nav-main-menu/nav-main-menu';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { PageArgs } from '../../../../models/projects/operation.models';
import { AppConfig } from '../../../../app/app.config';

@Component({
  selector: 'implementer-cancel-component',
  templateUrl: 'implementer-cancel-component.html'
})
export class ImplementerCancelComponent {
  @Output() goBack: EventEmitter<void> = new EventEmitter();
  @Input() snapshotSummary: ImplementerSnapshotSummary;

  config = AppConfig.settings;

  cancellationLoading: boolean;

  constructor(
    public navCtrl: NavController,
    private implementerService: ImplementerService,
    private navHelperService: NavHelperService,
  ) {
  }

  ngOnInit() {

  }

  async cancelChanges() {
    this.cancellationLoading = true;
    this.snapshotSummary = await this.implementerService.cancelImplementerChanges(this.config.isVesselEnvironment);

    if (this.snapshotSummary.cancellationDate && this.snapshotSummary.cancellationDate.dateTime) {
      const navPage = new PageArgs();
      navPage.page = DefaultPage;

      this.navHelperService.updateNavPage(navPage);
      this.navCtrl.setRoot(navPage.page);
      this.navHelperService.updateNavMenuPage({page: NavMainMenuPage});
    }

    this.cancellationLoading = false;
  }

  goBackClick() {
    this.goBack.emit();
  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-cancel/implementer-cancel-component/implementer-cancel-component.ts